module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Andrew Kelley-efe5a4bd60ef6d7eaa0ff71557323459.jpg";